import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface DialogData {
  titulo: string;
  tipo: EnumTipoMensaje;
  mensaje: string;
  mensajeHTML: string;
  img: string;
}

export abstract class MensajeTemplate {
  public static GeneradoExitoso = "Operación realizada exitosamente.";
  public static EnvioMailResetPassword = "Se ha enviado un email a la cuenta indicada con las instrucciones para recuperar la contraseña.";
  public static ErrorGenerico = "Se ha generado un error al procesar la solicitud.";
  public static ResetOk = "Se ha reseteado correctamente su contraseña."

}


export enum EnumTipoMensaje {
  Ok,
  Warining,
  Info,
  Error
}


export class MensajeDescripcion{

}

@Component({
  selector: "mensaje",
  templateUrl: "mensaje.component.html"
})
export class MensajeComponent {
  constructor(
    public dialogRef: MatDialogRef<MensajeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    data.titulo = this.getTitulo(data)
    this.getMensage(data)
  }

  getMensage(data){
    if (data.tipo == EnumTipoMensaje.Error){
      if(data.mensaje) {//es el error
        data.mensaje = data.mensaje.errorMensage
      }else{
        data.mensaje = MensajeTemplate.ErrorGenerico
    }
  }}

  getTitulo(data: DialogData) {
    switch (data.tipo) {
      case EnumTipoMensaje.Warining:
        return "Alerta.";
        case EnumTipoMensaje.Error:
        return "Oh! Se ha producido un error.";
        case EnumTipoMensaje.Info:
        return "Información.";
        case EnumTipoMensaje.Ok:
        return "¡Éxito!";
    }

  }

  cerrar() {
    this.dialogRef.close();
  }
}
